import styled from 'styled-components';
import {
  AA_LINK_ON_LIGHT,
  AA_SURFACE,
  AA_TEXT_PRIMARY_ON_LIGHT,
} from '~/modules/Helper/contrast.helper';

/**
 * Skip link (WCAG 2.4.1 / AccessMonitor a_01b).
 * Visível só no foco de teclado — deve ser o 1º link do documento.
 */
export const SkipLink = styled.a`
  position: absolute;
  left: 0.75rem;
  top: 0.75rem;
  z-index: 10000;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  background: ${AA_SURFACE};
  color: ${AA_LINK_ON_LIGHT};
  font-weight: 700;
  text-decoration: underline;
  box-shadow: 0 0 0 2px ${AA_TEXT_PRIMARY_ON_LIGHT};
  /* Fora da viewport até receber foco */
  transform: translateY(-200%);

  &:focus,
  &:focus-visible {
    transform: translateY(0);
    outline: 3px solid ${AA_LINK_ON_LIGHT};
    outline-offset: 2px;
  }
`;
